import { render, staticRenderFns } from "./MemberType.vue?vue&type=template&id=473c9ae4"
import script from "./MemberType.vue?vue&type=script&lang=js"
export * from "./MemberType.vue?vue&type=script&lang=js"
import style0 from "./MemberType.vue?vue&type=style&index=0&id=473c9ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports